<div class="flex w-full flex-col" [ngClass]="[containerClassName]">
  <!-- Top  Image Section -->
  @if (image) {
    <div class="flex h-full flex-col items-center gap-2.5 rounded-3xl p-6 lg:items-start"
         [ngClass]="[sectionClassName]">
      <div class="realtive relative flex w-full justify-center" [ngClass]="imageContainerClassName">
        @if (!imageLoaded()) {
          <hlm-skeleton class="absolute bottom-0 h-full w-full rounded-3xl bg-gray-200"/>
        }
        <img
          [ngSrc]="image"
          alt="Employee"
          width="385"
          height="256"
          [priority]="priority"
          (load)="imageLoaded.set(true)"
          class="max-h-[256px] max-w-[385px] rounded-3xl object-cover transition-opacity duration-500"
          [class.opacity-0]="!imageLoaded()"
          [class.opacity-100]="imageLoaded()"/>
      </div>
    </div>
  }

  @if (icon) {
    <div class="flex h-full flex-col items-center gap-2.5 rounded-3xl p-6 lg:items-start"
         [ngClass]="[sectionClassName]">
      <div class="flex w-full justify-center" [ngClass]="imageContainerClassName">
        <span [inlineSVG]="icon" class="text-foreground"></span>
      </div>
    </div>
  }

  <!-- Middle Section -->
  @if (title) {
    <div
      class="flex h-fit flex-col items-center gap-3 rounded-3xl p-6 lg:items-start"
      [ngClass]="[
        sectionClassName,
        alwaysShowShadow
          ? 'shadow-card-top-hover-light transition-all duration-300'
          : 'transition-all duration-300 group-hover:shadow-card-top-hover-light dark:group-hover:shadow-card-top-hover-dark',
      ]">
      <div class="flex w-full flex-col items-center gap-2 lg:items-start">
        <span [ngClass]="titleClassName" class="font-medium">{{ title }}</span>

        @if (subtitle) {
          <span [ngClass]="subtitleClassName">{{ subtitle }}</span>
        }

        @if (headerBadges) {
          <div class="flex flex-wrap gap-2.5">
            @for (badge of headerBadges; track badge) {
              <div
                class="flex items-center justify-center gap-2 rounded-lg border border-gray-200 bg-background px-2 py-0.5">
                <span class="h-1.5 w-1.5 rounded-[50%]" [ngStyle]="{ background: badge.color }"></span>
                <span class="text-[14px] text-secondary-foreground">{{ badge.title }}</span>
              </div>
            }
          </div>
        }
      </div>

      @if (footerBadges) {
        <div class="flex w-fit flex-wrap gap-4">
          @for (badge of footerBadges; track badge) {
            <div class="flex items-center gap-2">
              <lucide-icon [name]="badge.icon" size="20" class="text-tertiary-foreground"></lucide-icon>
              <span class="text-sm text-tertiary-foreground">{{ badge.title }}</span>
            </div>
          }
        </div>
      }

      @if (description && !highlightTitle) {
        <div [ngClass]="descriptionClassName">{{ description }}</div>
      }

      @if (showHeaderButtonBottom) {
        <button hlmBtn class="flex w-fit justify-start gap-2" [variant]="btnVariant" (click)="onHeaderButtonClick()">
          <span>{{ buttonText }}</span>
          <lucide-icon [name]="buttonIcon" size="20"></lucide-icon>
        </button>
      }
    </div>
  }

  @if (highlightTitle && description) {
    <div
      class="flex h-fit flex-col items-center gap-3 rounded-3xl p-6 lg:items-start"
      [ngClass]="[
        sectionClassName,
        alwaysShowShadow
          ? 'shadow-card-top-hover-light transition-all duration-300'
          : 'transition-all duration-300 group-hover:shadow-card-top-hover-light dark:group-hover:shadow-card-top-hover-dark',
      ]">
      <span [ngClass]="highlightTitleClassName">{{ highlightTitle }}</span>
      <div [ngClass]="descriptionClassName">{{ description }}</div>
    </div>
  }
</div>
